import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppService } from 'src/app/service/app.service';

@Component({
  selector: 'app-upload-status',
  templateUrl: './upload-status.page.html',
  styleUrls: ['./upload-status.page.scss'],
})
export class UploadStatusPage implements OnInit {

  @Input() data: any;

  constructor(
    public modalController: ModalController,
    public appService: AppService) { }

  ngOnInit() {

  }

  /**
   * @mathod { Dismiss the popup }
   */
  closePopup() {
    this.modalController.dismiss();
  }

  /**
   * @mathod { will copy the text }
   */
  copyText(link) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (link));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
    this.appService.toastMessage('Link copied')
  }

}
